import NanniesDirectories from 'pages/nannies'
export default NanniesDirectories
